import { useState, useEffect } from 'react'
import { isEmpty } from 'lodash'

import { MaskInput } from 'components/MaskInput'

export const InputPercentage = ({ value, onChange, disabled, ...props }: TSFixMe): TSFixMe => {
  const [inputValue, setInputValue] = useState(value.toString())

  const handleInputChange = (newValue: TSFixMe, mask: TSFixMe): TSFixMe => {
    setInputValue(newValue)
    if (value.toString() !== mask._unmaskedValue) {
      onChange(mask._unmaskedValue)
    }
  }

  useEffect((): TSFixMe => {
    setInputValue(value.toString())
  }, [value])

  return (
    <MaskInput
      lazy={isEmpty(value.toString())}
      mask={`num%`}
      blocks={{
        num: {
          mask: Number,
          scale: 2,
          radix: '.',
          padFractionalZeros: disabled,
          max: 100
        }
      }}
      value={inputValue}
      disabled={disabled}
      onAccept={handleInputChange}
      {...props}
    />
  )
}
